<template>
  <div class="intro-animation-end">
    <img
      :src="src"
      alt=""
      class="image"
      draggable="false"
    />
  </div>
</template>

<script>
import windowUtil from '@/utils/window'
import { fadeMixin } from '@/mixins'

export default {
  name: 'IntroChar',
  data () {
    return {
      src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      images: [{
        trigger: 400,
        src: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      }, {
        trigger: 440,
        src: require('@/assets/images/intro-sequence/7.png')
      }, {
        trigger: 480,
        src: require('@/assets/images/intro-sequence/6.png')
      }, {
        trigger: 520,
        src: require('@/assets/images/intro-sequence/5.png')
      }, {
        trigger: 560,
        src: require('@/assets/images/intro-sequence/4.png')
      }, {
        trigger: 620,
        src: require('@/assets/images/intro-sequence/3.png')
      }, {
        trigger: 680,
        src: require('@/assets/images/intro-sequence/2.png')
      }, {
        trigger: 740,
        src: require('@/assets/images/intro-sequence/1.png')
      }]
    }
  },
  methods: {
    onScroll () {
      const images = this.images.filter(img => img.trigger >= windowUtil.scrollFromTop).map(img => img.src)
      this.src = images.length ? images[0] : this.images[this.images.length - 1].src
    }
  },
  mixins: [fadeMixin]
}
</script>

<style lang="scss" scoped>
.intro-animation-end {
  width: 125px;
  height: auto;
  position: absolute;
  z-index: 3;
  left: 0;
  right: 0;
  margin: 0 auto;
  top: 0;

  @media (min-width: 768px) {
    top: -50px;
  }
}

.image {
  width: 125px;
  height: 216px;
}
</style>
